import {PasswordInput} from '../../PasswordInput/PasswordInput';
import {useFieldProps} from '../hooks/useFieldProps';
import {PasswordRendererResponseBody} from '../types/modelSchema';

export function PasswordRenderer(props: PasswordRendererResponseBody) {
  const {name, tooltip} = props;
  const {onChange, onBlur, onFocus, value, error, isRequired} = useFieldProps(props);

  return (
    <PasswordInput
      label={props.label}
      data-testid={name}
      onChange={onChange}
      tooltip={tooltip}
      onFocus={onFocus}
      onBlur={onBlur}
      isRequired={isRequired}
      errorMessage={error?.message}
      value={value || ''}
      isDisabled={props.isReadOnly}
    />
  );
}
